module.exports = __webpack_public_path__ + "media/images/85/gym-fb0e39da7989340d2583e9caf12be55d.jpg";